"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireDefault(require("react"));
require("./ErxNotificationsLink.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ErxNotificationsLink = function ErxNotificationsLink(_ref) {
  var count = _ref.count,
    url = _ref.url,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'warning' : _ref$icon,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Prescription errors:' : _ref$text;
  if (!count || !url) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "text-danger"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: icon
  }), " ", text, " ", count);
};
var _default = ErxNotificationsLink;
exports.default = _default;